import React from 'react';
import { EntityForm } from '../../widgets/Forms';
import { CustomTextField } from '../../widgets/CustomTextField';
import { SelectItem } from '../../widgets/SelectItem';

export default function SurveySearchForm(props) {
    return (
        <EntityForm ref={React.createRef()} viewId="provider" values={props.data}
            entityLookupController={props.entityLookupController} org="saseta"
            entityLookupId={props.id} useCustomSettings={false} valueChangeHandler={props.valueChangeHandler}>
            {form =>
                <form className={form.classes.container} id="SurveySearchForm">
                    <div className="row search-form-container">
                        <div className="col form-col">
                            <CustomTextField
                                id="SurveyNumber"
                                label="Survey Number"
                                className="w-100"
                                onKeyPress={props.onKeyUp}
                                InputProps={{
                                    readOnly: false,
                                }}
                                form={form}
                            />
                        </div>
                        <div className="col form-col">
                            <SelectItem
                                dataUrl="api/sims/Survey/GetLookupList?listId=SurveyStatus"
                                id="SurveyStatusID"
                                label="Survey Status"
                                className="w-100"
                                form={form}
                                allowEmptyValue={true}
                            />
                        </div>
                    </div>
                </form>
            }
        </EntityForm>
    );
}
